import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "google-map"
    }}>{`Google Map`}</h1>
    <h3 {...{
      "id": "uses"
    }}>{`Uses`}</h3>
    <p>{`Sometimes using Google Map API on the wordpress makes the frontend heavy and it makes the site slower. So the solution is loading the Google Map Api key asynchronously. Which is done in this Google Map Menu on the backend. (Make sure that you have disabled the Loading of Google Map API from anything outside such as the theme. As we have asynchronously loaded the Google Map API, It will serve better performance to the plugin as well as the theme)`}</p>
    <p>{`If you want to use Our Map Feature then this section is for you. First Go to your,`}</p>
    <pre><code parentName="pre" {...{}}>{`Admin -> Google Map menu,
`}</code></pre>
    <p>{`you will find the below options,`}</p>
    <blockquote>
      <p parentName="blockquote">{`NB: If you don't find this option or the Google map menu in your admin section please make sure you have Load Google Map plugin installed in your site. To know how to install this plugin you can either check our Installation section or you can download it from Admin -> Reactive menu.`}</p>
    </blockquote>
    <p>{`Here, you can Enable or Disable the`}</p>
    <ul>
      <li parentName="ul">{`Google map`}</li>
      <li parentName="ul">{`RichMarker`}</li>
      <li parentName="ul">{`Info Bubble`}</li>
      <li parentName="ul">{`Marker Cluster`}</li>
    </ul>
    <p>{`If you want to use the Google map, Make sure you Fill up the Google Map Api key, you can have a google map api key from the below url`}</p>
    <p><a parentName="p" {...{
        "href": "https://developers.google.com/maps/documentation/javascript/get-api-key"
      }}>{`Google Map Api Key`}</a></p>
    <p>{`To Enable Geobox on a Post type to use the Map Location Feature Please Follow the below section.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      